import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from 'src/app/layout/loading/loading.service';
import { InfoHTRsvDTO } from 'src/app/models/InfoHTRsv';
import { MstUserDTO } from 'src/app/models/MstUser';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { Utility } from 'src/app/shared/utility/utility';
import { SrcExamCourseSelService } from '../src-exam-course-sel/src-exam-course-sel.service';
import { ExamCourseSelDTO, Option } from 'src/app/models/ExamCourseSel';
import { ScreenMode } from 'src/app/shared/screen-mode';
import { IAppState } from 'src/app/store/states/app.state';
import { Store } from '@ngrx/store';
import { GetIMstHTOrg } from 'src/app/store/actions/mstHTOrg.action';
import { SrcReservationDetailService } from '../src-reservation-detail/src-reservation-detail.service';
import { DialogResult } from 'src/app/shared/dialog-modal/dialog-types';
import { DeactivateGuard } from 'src/app/can-deactivate-guard.service';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import * as moment from 'moment';
import { SrcReservationDateSelService } from '../src-reservation-date-sel/src-reservation-date-sel.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
/* 20231006 add #19525 start */ 
import { CommonService } from './../../../../services/common.service';
/* 20231006 add #19525 end */ 

@Component({
  selector: 'app-src-exam-course-sel',
  templateUrl: './src-exam-course-sel.component.html',
  styleUrls: ['./src-exam-course-sel.component.scss']
})
export class SrcExamCourseSelComponent implements OnInit, DeactivateGuard {
  typeMode = 1; // 1: add ; 2: edit; 3: e dit confirm
  lstCourse: any[] = [];
  lstOption: any[] = [];
  lstOptionCommon: any[] = [];
  HTOrgCode: any;
  dataReservation: any;
  oldDataReservation: any;
  objRsv = new InfoHTRsvDTO();
  objUser = new MstUserDTO();
  objCourse = new ExamCourseSelDTO();
  courseOld = new ExamCourseSelDTO();
  /*20240402 #21672 add start*/
  objCoursesession = new ExamCourseSelDTO();
  /*20240402 #21672 add end*/
  isCheckFullFrame: boolean = false;
  ReqPriceFractionCalDiv: any;
  TaxRate: any;
  selectedCourse: any;
  /*20240329 #21672 add start*/ 
  selectedCourseFirst: any;
  /*20240329 #21672 end start*/ 
  isLoadDataLocal = false;
  RsvDateParam: any;
  RsvNewDateParam: any;
  RsvNumParam: any;
  screenBack: any;
  CorrectAmount = 0;
  objCourseOld = new ExamCourseSelDTO();
  newFrameOption: MstExaminationFrame[];
  oldFrameOption: MstExaminationFrame[];
  /*20240329 #21672 add start*/ 
  oldFrameOptionBack: MstExaminationFrame[];
  /*20240329 #21672 end start*/ 
  oldReservationStat: any;
  newReservationStat: any;
  lstOptionOld: any[] = [];
  lstOptionCommonOld: any[] = [];
  startDate: any;
  endDate: any;
  isRedirect = false;
  isRedirecting = false;
  isCheckAge = false;
  constructor(
    private router: Router,
    public util: Utility,
    private loadingSrv: LoadingService,
    private dialogModalService: DialogModalService,
    public trans: TranslateService,
    private examCourseSelService: SrcExamCourseSelService,
    private routeActived: ActivatedRoute,
    private store: Store<IAppState>,
    private rsvDetailService: SrcReservationDetailService,
    private reservationDateSelService: SrcReservationDateSelService,
    /* 20231006 add #19525 start */ 
    private common: CommonService,
    /* 20231006 add #19525 end */ 
  ) { }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    window.history.forward()
  }
  ngOnInit(): void {
    this.util.resetZoomBrowser();
    this.preventButtonBackBrowser()
    const strHTOrgCode = sessionStorage.getItem('HTOrgCode');
    const dataLocal = sessionStorage.getItem('DataReservation');
    if (!this.util.isNullOrEmpty(strHTOrgCode) && !this.util.isNullOrEmpty(dataLocal)) {
      this.HTOrgCode = strHTOrgCode;
      this.dataReservation = JSON.parse(dataLocal);
      const dataLocalOld = sessionStorage.getItem('DataReservationOld');
      this.oldDataReservation = JSON.parse(dataLocalOld);
      this.courseOld = this.oldDataReservation?.objCourse;
      this.startDate = this.dataReservation?.objCourse?.RegStartDate;
      this.endDate = this.dataReservation?.objCourse?.RegEndDate;
      this.typeMode = 1;
      const strMode = this.routeActived.snapshot.queryParams.mode;
      const strBack = this.routeActived.snapshot.queryParams.back;
      if (!this.util.isNullOrBlank(strBack)) {
        this.screenBack = strBack;
      }
      if (!this.util.isNullOrEmpty(this.dataReservation.typeReservation) && strMode === ScreenMode.Edit) {
        this.typeMode = 2;
        const dataLocalOld = sessionStorage.getItem('DataReservationOld');
        const dataLocalNew = sessionStorage.getItem('DataReservation');
        const dataOld = JSON.parse(dataLocalOld);
        const dataNew = JSON.parse(dataLocalNew);
        if (!this.util.isNullOrEmpty(dataOld) && !this.util.isNullOrEmpty(dataOld.objRsvDateTime)) {
          this.RsvDateParam = dataOld.objRsvDateTime.RsvYMD;
          this.RsvNewDateParam = dataNew.objRsvDateTime.RsvYMD;
        }
      } else if (strMode === ScreenMode.Edit && this.util.isNullOrBlank(this.dataReservation.typeReservation)
        && !this.util.isNullOrEmpty(this.dataReservation.RsvNum)) {
        this.typeMode = 3;
        const dataLocalOld = sessionStorage.getItem('DataReservationOld');
        const dataLocalNew = sessionStorage.getItem('DataReservation');
        const dataOld = JSON.parse(dataLocalOld);
        const dataNew = JSON.parse(dataLocalNew);
        if (!this.util.isNullOrEmpty(dataOld)) {
          this.RsvDateParam = dataOld.RsvDate;
          this.RsvNumParam = dataOld.RsvNum;
          this.RsvNewDateParam = dataNew.objRsvDateTime.RsvYMD;
        }
        this.objRsv = this.dataReservation.objRsv;
      }
      if ((this.util.isNullOrEmpty(this.dataReservation.objRsv) && this.dataReservation.typeReservation === 1)
        || this.util.isNullOrEmpty(this.dataReservation.objUser)
        || (this.typeMode === 2 && this.util.isNullOrEmpty(this.dataReservation.isReservationDetail))
        || (strMode !== ScreenMode.Edit && this.util.isNullOrBlank(this.dataReservation.typeReservation))) {
        this.router.navigateByUrl('404');
        return;
      }
      if (!this.util.isNullOrEmpty(this.dataReservation.objCourse)) {
        this.isLoadDataLocal = true;
      }
      const objHTOrg = {
        HTOrgCode: null,
        HTOrgName: this.dataReservation.HTOrgName,
      };
      this.store.dispatch(new GetIMstHTOrg(objHTOrg));
      if (this.dataReservation.typeReservation === 1) {
        this.objRsv = this.dataReservation.objRsv;
      }
      this.objUser = this.dataReservation.objUser;
      this.getTaxRate();
      setTimeout(() => {
        this.util.addPerfectScrollBar();
        $('.scrollbar').scrollTop(0);
      }, 100);
    } else {
      this.router.navigateByUrl('404');
    }
  }
  SearchListMstHTCourse() {
    this.loadingSrv.setDisplay(true);
    const objSearch = {
      HTOrgCode: this.HTOrgCode,
      CoCode: this.objRsv?.CoCode ? this.objRsv?.CoCode : "",
      DateOfBirth: this.objUser?.DateOfBirth,
      Gender: this.objUser?.Gender,
      PersonFamilyDiv: this.objRsv?.PersonFamilyDiv ? this.objRsv?.PersonFamilyDiv : "",
      RsvYMD: this.typeMode === 3 ? this.RsvDateParam : null,
    };
    this.examCourseSelService.SearchListMstHTCourse(objSearch).subscribe(data => {
      if (data) {
        this.lstCourse = data;
        if (this.lstCourse && this.lstCourse.length > 0) {
          this.lstCourse.forEach(element => {
            element.ListExaminationType1 = [];
            element.ListExaminationType2 = [];
            if (element.ListExamination && element.ListExamination.length > 0) {
              element.ListExamination.forEach(el => {
                if (el.WebRsvDispDiv === '1') {
                  element.ListExaminationType1.push(el);
                } else if (el.WebRsvDispDiv === '2') {
                  element.ListExaminationType2.push(el);
                }
              });
            }
          });
          if (this.isLoadDataLocal) {
            const objCourse = this.lstCourse.find(x => x.CoCode === this.dataReservation?.objCourse?.CoCode
              && x.HTCourseCode === this.dataReservation?.objCourse?.HTCourseCode);
              /*20240329 #21672 add start*/ 
              /* 20241113 #20724 delete start */
              // objCourse.ListOption = this.dataReservation?.objCourse?.ListOption;
              /* 20241113 #20724 delete end */
              /*20240329 #21672 add end*/ 
              /*20240402 #21672 add start*/ 
              const firstObjCourse = sessionStorage.getItem('ObjCourseFirstDataReservation');
              if (this.util.isNullOrBlank(firstObjCourse)){
                sessionStorage.setItem('ObjCourseFirstDataReservation', JSON.stringify(objCourse));
              }
              /*20240402 #21672 add end*/ 
            if (!this.util.isNullOrEmpty(objCourse)) {
              /* 20241113 #20724 add start */
              objCourse.ListOption = this.dataReservation?.objCourse?.ListOption;
              /* 20241113 #20724 add end */
              this.changeSelectCourse(objCourse, true);
            } else {
              this.changeSelectCourse(this.lstCourse[0]);
            }
          } else {
            /*20240725 #21672 modify start*/ 
            // this.changeSelectCourse(this.lstCourse[0]);
            this.changeSelectCourse(this.lstCourse[0],false,true);
            /*20240725 #21672 modify end*/ 
          }
        }
      }
      this.loadingSrv.setDisplay(false);
    }, err => {
      this.loadingSrv.setDisplay(false);
    }, () => {
      if (this.typeMode === 3 && !this.screenBack) {
        setTimeout(() => {
          this.objCourseOld = JSON.parse(JSON.stringify(this.objCourse));
        }, 0);
      }
    });
  }
  /* 20240918 #20724 add start */
  /* 20241106 #20724 modify start */
  // calculateOddEvenAgeDiv()
  calculateOddEvenAgeDiv(ageCalculateDiv)
  /* 20241106 #20724 modify end */
  {
    if (!this.objUser?.DateOfBirth || !this.RsvDateParam) {
      return '';
    }

    const birthDate = moment(this.objUser.DateOfBirth);
    /* 20241106 #20724 modify start */
    // const reservationDate = moment(this.RsvDateParam);
    // const age = reservationDate.diff(birthDate, 'years');
    var age = 0;
    if (ageCalculateDiv == "2") {
      // �N�x��
      const rsvDate = moment(this.RsvNewDateParam);
      const rsvYear = rsvDate.year();
      const marchLast = moment(`${rsvYear}-03-31`);
      
      if (rsvDate.isAfter(marchLast)) {
        const nextYear = rsvYear + 1;
        age = moment(`${nextYear}-03-31`).diff(birthDate, 'years');
      } else {
        age = marchLast.diff(birthDate, 'years');
      }
    } else if (ageCalculateDiv == "3") {
      // �N��
      const rsvDate = moment(this.RsvNewDateParam);
      const rsvYear = rsvDate.year();
      /* 20241112 #20724 modify start */
      /* const lastDay = moment(`${rsvYear}-12-31`);
      age = lastDay.diff(birthDate, 'years'); */
      const marchLast = moment(`${rsvYear}-03-31`);

      if (rsvDate.isAfter(marchLast)) {
        age = moment(`${rsvYear}-12-31`).diff(birthDate, 'years');
      } else {
        const lastYear = rsvYear - 1;
        age = moment(`${lastYear}-12-31`).diff(birthDate, 'years');
      }
      /* 20241112 #20724 modify end */
    } else if (ageCalculateDiv == "4") {
      // ������
      const rsvDate = moment(this.RsvNewDateParam);
      const rsvYear = rsvDate.year();
      /* 20241227 #23633 modify start */
      // const aprilFirst = moment(`${rsvYear}-04-01`);
      /* 20250113 #23633 modify start */
      // const aprilFirst = moment(`${rsvYear}-03-31`);
      const aprilFirst = moment(`${rsvYear}-04-01`);
      /* 20250113 #23633 modify end */
      /* 20241227 #23633 modify end */
      
      if (rsvDate.isAfter(aprilFirst)) {
        const nextYear = rsvYear + 1;
        /* 20241227 #23633 modify start */
        // age = moment(`${nextYear}-04-01`).diff(birthDate, 'years');
        /* 20250113 #23633 modify start */
        // age = moment(`${nextYear}-03-31`).diff(birthDate, 'years');
        age = moment(`${nextYear}-04-01`).diff(birthDate, 'years');
        /* 20250113 #23633 modify end */
        /* 20241227 #23633 modify end */
      } else {
        age = aprilFirst.diff(birthDate, 'years');
      }
    } else {
      // ��f�� & ���̑�
      age = moment(this.RsvNewDateParam).diff(birthDate, 'years');
    }
    /* 20241106 #20724 modify end */

    return age % 2 === 0 ? '2' : '1';
  }
  /* 20240918 #20724 add end */
  changeSelectCourse(item, isSelect = false, isClick = false) {
    this.loadingSrv.setDisplay(true);
    this.lstCourse.map(a => a.Checked = false);
    item.Checked = true;
    /*20240329 #21672 add start*/ 
    if(isClick == false){
      /*20240402 #21672 add start*/ 
      const firstObjCourse = sessionStorage.getItem('selectedCourseFirst');
      if (this.util.isNullOrBlank(firstObjCourse)){
        sessionStorage.setItem('selectedCourseFirst', JSON.stringify(item));
      }
      /*20240402 #21672 add end*/ 
    }
    /*20240329 #21672 add end*/ 
    this.selectedCourse = item;
    this.objCourse.HTCourseName = item.HTCourseName;
    this.objCourse.CoCode = item.CoCode;
    this.objCourse.HTCourseCode = item.HTCourseCode;
    this.objCourse.PersonalReqPrice = item.PersonalReqPrice;
    this.objCourse.AgeCalculateDiv = item.AgeCalculateDiv;

    this.objCourse.AgeLowLimit = item.AgeLowLimit;
    this.objCourse.AgeUpLimit = item.AgeUpLimit;
    /*20240329 #21672 add start*/ 
    this.objCourse.ListOption = item.ListOption;
    /*20240329 #21672 add end*/ 

    this.objCourse.CoReqPrice = item.CoReqPrice;
    this.objCourse.InsuranceReqPrice = item.InsuranceReqPrice;
    this.objCourse.OtherReqPrice = item.OtherReqPrice;
    this.objCourse.InsuranceReqUpLimitPrice = item.InsuranceReqUpLimitPrice;
    this.objCourse.UplimitCorrectPriceDiv = item.UplimitCorrectPriceDiv;
    this.objCourse.CoReqUpLimitPrice = item.CoReqUpLimitPrice;
    this.objCourse.OtherReqUpLimitPrice = item.OtherReqUpLimitPrice;
    this.objCourse.HTCourseDiv = item.HTCourseDiv;
    this.objCourse.PersonFamilyDiv = item.PersonFamilyDiv;
    const objSearch = {
      HTOrgCode: this.HTOrgCode,
      HTCourseCode: this.objCourse.HTCourseCode,
      CoCode: this.objCourse?.CoCode ? this.objCourse?.CoCode : "",
      // 20231213 modify #20903 start
      HTCourseCodeOLD: this.objCourse.HTCourseCode,
      CoCodeOLD: this.objCourse?.CoCode ? this.objCourse?.CoCode : "",
      // 20231213 modify #20903 end
      DateOfBirth: this.objUser?.DateOfBirth,
      Gender: this.objUser?.Gender,
      PersonFamilyDiv: this.objRsv?.PersonFamilyDiv ? this.objRsv?.PersonFamilyDiv : "",
      AgeCalculateDiv: item.AgeCalculateDiv,
      OddEvenAgeDiv: item.OddEvenAgeDiv,
      RsvYMD: this.typeMode === 3 ? this.RsvDateParam : null,
    };
    this.lstOption = [];
    this.examCourseSelService.SearchListOption(objSearch).subscribe(data => {
      /* 20240918 #20724 add start */
      /* 20241106 #20724 modify start */
      // const userOddEvenAgeDiv = this.calculateOddEvenAgeDiv();
      const userOddEvenAgeDiv = this.calculateOddEvenAgeDiv(objSearch.AgeCalculateDiv);
      /* 20241106 #20724 modify end */
      /* 20240918 #20724 add end */
      if (data) {
        if (data.ListOption && data.ListOption.length > 0) {
          this.lstOption = data.ListOption;
          this.lstOption.map(x => x.Checked = false);
          /* 20240918 #20724 add start */
          if (!this.util.isNullOrEmpty(userOddEvenAgeDiv)) {
            this.lstOption = this.lstOption.filter(x => x.OddEvenAgeDiv !== userOddEvenAgeDiv || this.util.isNullOrEmpty(x.OddEvenAgeDiv));
          }
          /* 20241107 #20724 add start */
          this.lstOption = this.lstOption.filter(x => x.Gender == "3" || this.util.isNullOrEmpty(x.Gender)  || x.Gender == this.objUser?.Gender);
          /* 20241107 #20724 add end */
          /* 20240918 #20724 add end */
        }
        if (data.ListOptionCommon && data.ListOptionCommon.length > 0) {
          this.lstOptionCommon = data.ListOptionCommon;
          this.lstOptionCommon.map(x => x.Checked = false);
          /* 20240918 #20724 add start */
          if (!this.util.isNullOrEmpty(userOddEvenAgeDiv)) {
            /* 20241107 #20724 modify start */
            // this.lstOption = this.lstOption.filter(x => x.OddEvenAgeDiv !== userOddEvenAgeDiv || this.util.isNullOrEmpty(x.OddEvenAgeDiv));
            this.lstOptionCommon = this.lstOptionCommon.filter(x => x.OddEvenAgeDiv !== userOddEvenAgeDiv || this.util.isNullOrEmpty(x.OddEvenAgeDiv));
            /* 20241107 #20724 modify end */
          }
          /* 20241107 #20724 add start */
          this.lstOptionCommon = this.lstOptionCommon.filter(x => x.Gender == "3" || this.util.isNullOrEmpty(x.Gender) || x.Gender == this.objUser?.Gender);
          /* 20241107 #20724 add end */
          /* 20240918 #20724 add end */ 
        }
        if(data.ListOption.length > 0 && data.ListOptionCommon.length > 0) {
          const commonOpt = this.lstOptionCommon?.filter((res:Option) => {return this.lstOption?.find((opt:Option) => {return opt.HTSetItemCode === res.HTSetItemCode})})
          _.remove(this.lstOptionCommon, (res:Option) => { return  commonOpt.find((opt:Option) => res.HTSetItemCode === opt.HTSetItemCode)})
        } 
      }
    }, err => {
      this.loadingSrv.setDisplay(false);
    }, () => {
      if (isSelect) {
        this.lstOption.forEach(element => {
          /* 20240918 #20724 modify start */
          // const objCheck = this.dataReservation?.objCourse?.ListOption?.find(x => x.HTSetItemCode === element.HTSetItemCode);
          const objCheck = this.dataReservation?.objCourse?.ListOption?.find(x => x.HTSetItemCode?.trim() === element.HTSetItemCode?.trim());
          /* 20240918 #20724 modify end */
          if (!this.util.isNullOrEmpty(objCheck)) {
            element.Checked = true;
          }
        });
        this.lstOptionCommon.forEach(element => {
          /* 20240918 #20724 modify start */
          // const objCheck = this.dataReservation?.objCourse?.ListOption?.find(x => x.HTSetItemCode === element.HTSetItemCode);
          const objCheck = this.dataReservation?.objCourse?.ListOption?.find(x => x.HTSetItemCode.trim() === element.HTSetItemCode.trim());
          /* 20240918 #20724 modify end */
          if (!this.util.isNullOrEmpty(objCheck)) {
            element.Checked = true;
          }
        });
      }
      this.setTotalPrice();
      if (!isClick && this.typeMode === 3) {
        this.lstOptionOld = JSON.parse(JSON.stringify(this.lstOption));
        this.lstOptionCommonOld = JSON.parse(JSON.stringify(this.lstOptionCommon));
      }
      this.loadingSrv.setDisplay(false);
    });
  }
  ButtonBack() {
    this.isRedirecting = true;
    if (this.typeMode === 2) {
      /* 20241108 #20724 add start */
      const dataLocalOld = sessionStorage.getItem('DataReservationOld');
      if (!this.util.isNullOrEmpty(dataLocalOld)) {
        const dataOld = JSON.parse(dataLocalOld);
        this.dataReservation.objCourse = dataOld.objCourse;
        this.dataReservation.objUser = dataOld.objUser;
        sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
      }
      /* 20241108 #20724 add end */
      if (this.screenBack === '0303') {
        this.router.navigate(['personal-inf-inp'], {
          queryParams: {
            mode: ScreenMode.Edit
          }
        });
      } else if (this.screenBack === '0302') {
        this.router.navigate(['insurance-inp'], {
          queryParams: {
            mode: ScreenMode.Edit
          }
        });
      } else {
        this.router.navigateByUrl('reservation-detail');
      }
    } else if (this.typeMode === 3) {
      const dataLocalOld = sessionStorage.getItem('DataReservationOld');
      if (!this.util.isNullOrEmpty(dataLocalOld)) {
        const dataOld = JSON.parse(dataLocalOld);
        this.dataReservation.objCourse = dataOld.objCourse;
        /* 20241108 #20724 add start */
        this.dataReservation.objUser = dataOld.objUser;
        /* 20241108 #20724 add end */
        sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
      }
      if (this.screenBack === '0303') {
        this.router.navigate(['personal-inf-inp'], {
          queryParams: {
            mode: ScreenMode.Edit
          }
        });
      } else if (this.screenBack === '0302') {
        this.router.navigate(['insurance-inp'], {
          queryParams: {
            mode: ScreenMode.Edit
          }
        });
      } else {
        this.router.navigate(['reservation-detail'], {
          queryParams: {
            mode: ScreenMode.Edit, date: this.RsvDateParam, num: this.RsvNumParam, htorgcode: this.HTOrgCode
          }
        });
      }
    } else {
      this.router.navigateByUrl('personal-inf-inp');
    }
  }
  ButtonNext() {
    this.saveDataLocal();
    this.isRedirecting = true;
    this.router.navigateByUrl('reservation-date-sel');
  }
  saveDataLocal() {
    this.objCourse.ListOption = [];
    const lstOptionCheck = this.lstOption.filter(x => x.Checked);
    if (lstOptionCheck && lstOptionCheck.length > 0) {
      lstOptionCheck.forEach(element => {
        this.objCourse.ListOption.push(element);
      });
    }
    const lstOptionCommonCheck = this.lstOptionCommon.filter(x => x.Checked);
    if (lstOptionCommonCheck && lstOptionCommonCheck.length > 0) {
      lstOptionCommonCheck.forEach(element => {
        this.objCourse.ListOption.push(element);
      });
    }
    this.dataReservation.objCourse = this.objCourse;
    const dataSave = JSON.parse(JSON.stringify(this.dataReservation));
    delete dataSave.objCourse.TotalPrice;
    sessionStorage.setItem('DataReservation', JSON.stringify(dataSave));
  }
  ButtonEdit() {
    this.saveDataLocal();
    /* 20250422 #24406 modify start */
    const birthDate = moment(this.objUser.DateOfBirth);
    var age = 0;
    if (this.objCourse.AgeCalculateDiv == "2") {
      // �N�x��
      const rsvDate = moment(this.RsvNewDateParam);
      const rsvYear = rsvDate.year();
      const marchLast = moment(`${rsvYear}-03-31`);
      
      if (rsvDate.isAfter(marchLast)) {
        const nextYear = rsvYear + 1;
        age = moment(`${nextYear}-03-31`).diff(birthDate, 'years');
      } else {
        age = marchLast.diff(birthDate, 'years');
      }
    } else if (this.objCourse.AgeCalculateDiv == "3") {
      // �N��
      const rsvDate = moment(this.RsvNewDateParam);
      const rsvYear = rsvDate.year();
      const marchLast = moment(`${rsvYear}-03-31`);
      if (rsvDate.isAfter(marchLast)) {
        age = moment(`${rsvYear}-12-31`).diff(birthDate, 'years');
      } else {
        const lastYear = rsvYear - 1;
        age = moment(`${lastYear}-12-31`).diff(birthDate, 'years');
      }
    } else if (this.objCourse.AgeCalculateDiv == "4") {
      // ������
      const rsvDate = moment(this.RsvNewDateParam);
      const rsvYear = rsvDate.year();
      const aprilFirst = moment(`${rsvYear}-04-01`);
      if (rsvDate.isAfter(aprilFirst)) {
        const nextYear = rsvYear + 1;
        age = moment(`${nextYear}-04-01`).diff(birthDate, 'years');
      } else {
        age = aprilFirst.diff(birthDate, 'years');
      }
    } else {
      // ��f�� & ���̑�
      age = moment(this.RsvNewDateParam).diff(birthDate, 'years');
    }
    if (!this.util.isNullOrBlank(this.objCourse.AgeLowLimit) || !this.util.isNullOrBlank(this.objCourse.AgeUpLimit)) {
      if (!this.util.isNullOrBlank(this.objCourse.AgeLowLimit)) {
        if (age < Number(this.objCourse.AgeLowLimit)) {
          this.isCheckAge = true;
        }
      }
      if (!this.util.isNullOrBlank(this.objCourse.AgeLowLimit)) {
        if (age > Number(this.objCourse.AgeUpLimit)) {
          this.isCheckAge = true;
        }
      }
    }
    if (this.isCheckAge) {
      const strMess = this.trans.instant('MESS_CNF_COURSE_INFO_CHANGED_HAVETO_RERESV');
      this.dialogModalService.openConfirmModal(strMess).subscribe((res: DialogResult) => {
        if (res.isOk()) {
          this.isRedirecting = true;;
          this.router.navigate(['reservation-date-sel'], {
            queryParams: {
              mode: ScreenMode.Edit, back: true, isclick: true,
            }
          });
          return false;
        }
      });
    }else{
      if (this.typeMode === 2) {
        this.isRedirecting = true;
        this.checkDateRsvTypeModeTwo()
      } else if (this.typeMode === 3) {
        this.checkDateRsv();
      }
    }
    /* 20250422 #24406 modify end */
  }
  convertPrice(value: any) {
    return this.util.calculateFormatCurrency(value, this.TaxRate, this.ReqPriceFractionCalDiv);
  }
  getTaxRate() {
    this.loadingSrv.setDisplay(true);
    const objSearch = { HTOrgCode: this.HTOrgCode };
    this.examCourseSelService.getTaxRate(objSearch).subscribe(data => {
      if (data) {
        this.TaxRate = data.TaxRate;
        this.ReqPriceFractionCalDiv = data.ReqPriceFractionCalDiv;
      }
    }, err => {
      this.loadingSrv.setDisplay(false);
    }, () => {
      this.SearchListMstHTCourse();
    });
  }
  changeOption() {
    this.setTotalPrice();
  }
  setTotalPrice() {
    const lstOption = this.lstOption.concat(this.lstOptionCommon);
    const lstOptionCheck = lstOption.filter(o => o.Checked);
    const calcTotalPrice = this.util.calcTotalPrice(this.selectedCourse, lstOptionCheck);
    this.objCourse.TotalPrice = calcTotalPrice.TotalPrice;
    this.CorrectAmount = calcTotalPrice.CorrectAmount;
  }
  checkDateRsv() {
    this.loadingSrv.setDisplay(true);
    this.isCheckFullFrame = false;
    const objSearch = {
      StartDate: this.dataReservation?.objRsvDateTime?.RsvYMD,
      EndDate: this.dataReservation?.objRsvDateTime?.RsvYMD,
      HTOrgCode: this.HTOrgCode,
      RsvGender: this.objUser?.Gender,
      HTCourseCode: this.objCourse.HTCourseCode,
      CoCode: this.objCourse.CoCode,
      HTSetItemCode: this.getListHTSetItemCode(),
      RsvTime: this.dataReservation?.objRsvDateTime.RsvTime,
      DateOfBirth: this.objUser?.DateOfBirth,
    };
    this.rsvDetailService.checkDateTimeRsv(objSearch).subscribe(async data => {
      if (data && data.length > 0 && !this.util.isNullOrEmpty(data[0].ExaminationFrameCode)) {
        await this.checkChangeFrameOption()
        if(this.isCheckFullFrame) {
          const strMess = this.trans.instant('MESS_CNF_COURSE_INFO_CHANGED_HAVETO_RERESV');
          this.dialogModalService.openConfirmModal(strMess).subscribe((res: DialogResult) => {
            if (res.isOk()) {
              this.isRedirecting = true;
              this.router.navigate(['reservation-date-sel'], {
                queryParams: {
                  /*20240412 modify #21672 start */
                  // mode: ScreenMode.Edit, back: true, 
                  mode: ScreenMode.Edit, back: true, isclick: true,
                  /*20240412 modify #21672 end */
                }
              });
            }
          });
          this.loadingSrv.setDisplay(false);
        } else {
          this.isRedirecting = true;
          this.router.navigate(['reservation-detail'], {
            queryParams: {
              mode: ScreenMode.Edit, date: this.RsvDateParam, num: this.RsvNumParam, htorgcode: this.HTOrgCode
            }
          });
        }
      } else {
        await this.checkChangeFrameOption()
        /* 20241108 #20724 add start */
        if (this.courseOld && this.courseOld.ListOption && this.courseOld.ListOption.some(x => x.Gender != '3' && x.Gender != this.objUser?.Gender)) {
          this.isCheckFullFrame = true;
        }
        /* 20250417 #24407 modify start */
        // if (this.newFrameOption && this.newFrameOption.filter(x => x.RsvYMD == this.dataReservation?.objRsvDateTime.RsvYMD && x.RsvTime == this.dataReservation?.objRsvDateTime.RsvTime)?.some(x => x.Gender != '3' && x.Gender != this.objUser?.Gender)){
        if (this.newFrameOption && this.newFrameOption.filter(x => x.RsvYMD == this.dataReservation?.objRsvDateTime.RsvYMD && x.RsvTime == this.dataReservation?.objRsvDateTime.RsvTime)?.some(x => (x.Gender ? (x.Gender != '3' && x.Gender != this.objUser?.Gender) : (x.RsvGender != '3' && x.RsvGender != this.objUser?.Gender)))){
        /* 20250417 #24407 modify end */
          this.isCheckFullFrame = true;
        }
        /* 20250417 #24407 modify start */
        // if (this.oldFrameOptionBack && this.oldFrameOptionBack.filter(x => x.RsvYMD == this.dataReservation?.objRsvDateTime.RsvYMD && x.RsvTime == this.dataReservation?.objRsvDateTime.RsvTime)?.some(x => x.Gender != '3' && x.Gender != this.objUser?.Gender)){
        if (this.oldFrameOptionBack && this.oldFrameOptionBack.filter(x => x.RsvYMD == this.dataReservation?.objRsvDateTime.RsvYMD && x.RsvTime == this.dataReservation?.objRsvDateTime.RsvTime)?.some(x => (x.Gender ? (x.Gender != '3' && x.Gender != this.objUser?.Gender) : (x.RsvGender != '3' && x.RsvGender != this.objUser?.Gender)))){
        /* 20250417 #24407 modify end */
          this.isCheckFullFrame = true;
        }
        /* 20241108 #20724 add end */
        if(this.isCheckFullFrame) {
          const strMess = this.trans.instant('MESS_CNF_COURSE_INFO_CHANGED_HAVETO_RERESV');
          this.dialogModalService.openConfirmModal(strMess).subscribe((res: DialogResult) => {
            if (res.isOk()) {
              this.isRedirecting = true;
              this.router.navigate(['reservation-date-sel'], {
                queryParams: {
                  /*20240412 modify #21672 start */
                  // mode: ScreenMode.Edit, back: true, 
                  mode: ScreenMode.Edit, back: true, isclick: true,
                  /*20240412 modify #21672 end */
                }
              });
            } else if(res.isNo) {
            }
          });
          this.loadingSrv.setDisplay(false);
        } else {
          this.isRedirecting = true;
          this.router.navigate(['reservation-detail'], {
            queryParams: {
              mode: ScreenMode.Edit, date: this.RsvDateParam, num: this.RsvNumParam, htorgcode: this.HTOrgCode
            }
          });
        }
      }
    }, err => {
      this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED');
      this.loadingSrv.setDisplay(false);
    }, () => {
    });
  }
  checkDateRsvTypeModeTwo() {
    this.loadingSrv.setDisplay(true);
    this.isCheckFullFrame = false;
    const objSearch = {
      StartDate: this.dataReservation?.objRsvDateTime?.RsvYMD,
      EndDate: this.dataReservation?.objRsvDateTime?.RsvYMD,
      HTOrgCode: this.HTOrgCode,
      RsvGender: this.objUser?.Gender,
      HTCourseCode: this.objCourse.HTCourseCode,
      CoCode: this.objCourse.CoCode,
      HTSetItemCode: this.getListHTSetItemCode(),
      RsvTime: this.dataReservation?.objRsvDateTime.RsvTime,
      DateOfBirth: this.objUser?.DateOfBirth,
    };
    this.rsvDetailService.checkDateTimeRsv(objSearch).subscribe(async data => {
      if (data && data.length > 0 && !this.util.isNullOrEmpty(data[0].ExaminationFrameCode)) {
        await this.checkChangeFrameOption()
        if(this.isCheckFullFrame) {
          const strMess = this.trans.instant('MESS_CNF_COURSE_INFO_CHANGED_HAVETO_RERESV');
          this.dialogModalService.openConfirmModal(strMess).subscribe((res: DialogResult) => {
            if (res.isOk()) {
              this.isRedirecting = true;
              this.router.navigate(['reservation-date-sel'], {
                queryParams: {
                  /*20240412 modify #21672 start */
                  // mode: ScreenMode.Edit, back: true, 
                  mode: ScreenMode.Edit, back: true, isclick: true,
                  /*20240412 modify #21672 end */
                }
              });
            }
          });
          this.loadingSrv.setDisplay(false);
        } else {
          this.isRedirecting = true;
          this.router.navigateByUrl('reservation-detail');
        }
      } else {
        await this.checkChangeFrameOption()
        /* 20241108 #20724 add start */
        if (this.courseOld && this.courseOld.ListOption && this.courseOld.ListOption.some(x => x.Gender != '3' && x.Gender != this.objUser?.Gender)) {
          this.isCheckFullFrame = true;
        }
        /* 20250417 #24407 modify start */
        // if (this.newFrameOption && this.newFrameOption.filter(x => x.RsvYMD == this.dataReservation?.objRsvDateTime.RsvYMD && x.RsvTime == this.dataReservation?.objRsvDateTime.RsvTime)?.some(x => x.Gender != '3' && x.Gender != this.objUser?.Gender)){
        if (this.newFrameOption && this.newFrameOption.filter(x => x.RsvYMD == this.dataReservation?.objRsvDateTime.RsvYMD && x.RsvTime == this.dataReservation?.objRsvDateTime.RsvTime)?.some(x => (x.Gender ? (x.Gender != '3' && x.Gender != this.objUser?.Gender) : (x.RsvGender != '3' && x.RsvGender != this.objUser?.Gender)))){
        /* 20250417 #24407 modify end */
          this.isCheckFullFrame = true;
        }
        /* 20250417 #24407 modify start */
        // if (this.oldFrameOptionBack && this.oldFrameOptionBack.filter(x => x.RsvYMD == this.dataReservation?.objRsvDateTime.RsvYMD && x.RsvTime == this.dataReservation?.objRsvDateTime.RsvTime)?.some(x => x.Gender != '3' && x.Gender != this.objUser?.Gender)){
        if (this.oldFrameOptionBack && this.oldFrameOptionBack.filter(x => x.RsvYMD == this.dataReservation?.objRsvDateTime.RsvYMD && x.RsvTime == this.dataReservation?.objRsvDateTime.RsvTime)?.some(x => (x.Gender ? (x.Gender != '3' && x.Gender != this.objUser?.Gender) : (x.RsvGender != '3' && x.RsvGender != this.objUser?.Gender)))){
        /* 20250417 #24407 modify end */
          this.isCheckFullFrame = true;
        }
        /* 20241108 #20724 add end */
        if(this.isCheckFullFrame) {
          const strMess = this.trans.instant('MESS_CNF_COURSE_INFO_CHANGED_HAVETO_RERESV');
          this.dialogModalService.openConfirmModal(strMess).subscribe((res: DialogResult) => {
            if (res.isOk()) {
              this.isRedirecting = true;
              this.router.navigate(['reservation-date-sel'], {
                queryParams: {
                  /*20240412 modify #21672 start */
                  // mode: ScreenMode.Edit, back: true, 
                  mode: ScreenMode.Edit, back: true, isclick: true,
                  /*20240412 modify #21672 end */
                }
              });
            } else if(res.isNo) {
            }
          });
          this.loadingSrv.setDisplay(false);
        } else {
          this.isRedirecting = true;
          this.router.navigateByUrl('reservation-detail');
        }
      }
    }, err => {
      this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED');
      this.loadingSrv.setDisplay(false);
    }, () => {
    });
  }
  getListHTSetItemCode() {
    const lstOption = [];
    this.objCourse.ListOption.forEach(element => {
      lstOption.push(element.HTSetItemCode);
    });
    return lstOption;
  }
  checkChangeData() {
    const dataLocalOld = sessionStorage.getItem('DataReservationOld');
    const dataOld = JSON.parse(dataLocalOld);
    const lstOption = [];
    const lstOptionCheck = this.lstOption?.filter(x => x.Checked);
    if (lstOptionCheck && lstOptionCheck.length > 0) {
      lstOptionCheck.forEach(element => {
        lstOption.push(element.HTSetItemCode);
      });
    }
    const lstOptionCommonCheck = this.lstOptionCommon.filter(x => x.Checked);
    if (lstOptionCommonCheck && lstOptionCommonCheck.length > 0) {
      lstOptionCommonCheck.forEach(element => {
        lstOption.push(element.HTSetItemCode);
      });
    }
    if (!this.util.isNullOrEmpty(dataOld)) {
      // tslint:disable-next-line:prefer-for-of
      for (let index = 0; index < lstOption.length; index++) {
        const element = lstOption[index];
        const check = dataOld.objCourse?.ListOption?.find(x => x.HTSetItemCode === element);
        if (this.util.isNullOrEmpty(check)) {
          return true;
        }
      }
      if (this.objCourse.CoCode !== dataOld.objCourse.CoCode
        || this.objCourse.HTCourseCode !== dataOld.objCourse.HTCourseCode
        || lstOption.length !== dataOld.objCourse?.ListOption?.length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  // Show poup when change data
  setDeactivateState(nextState) {
    if (this.isRedirecting) {
      this.isRedirect = true;
    }
    else {
      const checkChange = this.checkDataChangeRedirect();
      if (checkChange || this.typeMode === 1 || this.typeMode === 2) {
        /*20240311 #21672 modify start*/
        /*const message = this.trans.instant('MESS_CNF_CHANGESCREEN_WITHOUT_REGIS');
        this.dialogModalService.openConfirmModal(message).subscribe((res: DialogResult) => {
          if (res.isOk()) {
            this.isRedirect = true;
            this.isRedirecting = true;
            this.setHTOrgName('');
            this.removeDataToSession();
            this.router.navigate([nextState]);
          }
        });*/
        const message = this.trans.instant('MESS_CNF_CHANGESCREEN_WITHOUT_REGIS');
        if (nextState == '/404') {
          
        }
        else{
          this.dialogModalService.openConfirmModal(message).subscribe((res: DialogResult) => {
            if (res.isOk()) {
              this.isRedirect = true;
              this.isRedirecting = true;
              this.setHTOrgName('');
              this.removeDataToSession();
              this.router.navigateByUrl(nextState);
            }
          });
        }
        /*20240311 #21672 modify end*/
      } else {
        this.isRedirect = true;
      }
    }
  }
  // Show poup when change data
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.isRedirect;
  }
  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
    if (this.checkDataChangeRedirect() || this.typeMode === 1 || this.typeMode === 2) {
      return false;
    } else {
      return true;
    }
  }
  setHTOrgName(pHTOrgName) {
    const objHTOrg = {
      HTOrgCode: null,
      HTOrgName: pHTOrgName,
    };
    this.store.dispatch(new GetIMstHTOrg(objHTOrg));
  }
  removeDataToSession() {
    sessionStorage.removeItem('HTOrgCode');
    sessionStorage.removeItem('DataReservation');
    sessionStorage.removeItem('DataReservationOld');
  }
  checkDataChangeRedirect() {
    const dataLocal = sessionStorage.getItem('DataReservation');
    const dataLocalOld = sessionStorage.getItem('DataReservationOld');
    if (!this.util.isNullOrBlank(dataLocal) && !this.util.isNullOrBlank(dataLocalOld) && (dataLocal !== dataLocalOld
     || JSON.stringify(this.objCourse) !== JSON.stringify(JSON.parse(dataLocalOld).objCourse))) {
      return true;
    } else {
      return false;
    }
  }
  private preventButtonBackBrowser() {
    history.pushState(null,"", window.location.href);  
  }
  private async getFrameOption(htSetItemCode:any) {
    const dateSelect = this.RsvNewDateParam;
    const objSearch = {
      RsvYMD: dateSelect,
      HTOrgCode: this.HTOrgCode,
      RsvGender: this.objUser.Gender,
      HTCourseCode: this.dataReservation.objCourse?.HTCourseCode,
      CoCode: this.dataReservation.objCourse?.CoCode,
      HTSetItemCode: htSetItemCode,
    };
    return new Promise<any>((resolve) => {
      this.reservationDateSelService.searchReservationStatusByDay(objSearch).subscribe(data => {
        return resolve(data);
    }, err => {
      this.loadingSrv.setDisplay(false);
    });
    })

  }
  /*20240329 #21672 add start*/ 
  private async getOldFrameOption(htSetItemCode:any) {
    const dateSelect = this.RsvNewDateParam;
    const objSearch = {
      RsvYMD: dateSelect,
      HTOrgCode: this.HTOrgCode,
      RsvGender: this.objUser.Gender,
      HTCourseCode: this.courseOld?.HTCourseCode,
      CoCode: this.courseOld?.CoCode,
      HTSetItemCode: htSetItemCode,
    };
    return new Promise<any>((resolve) => {
      this.reservationDateSelService.searchReservationStatusByDay(objSearch).subscribe(data => {
        return resolve(data);
    }, err => {
      this.loadingSrv.setDisplay(false);
    });
    })
  }
  /*20240329 #21672 end start*/ 
  private async checkChangeFrameOption() {
    /*20240320 #21672 delete start*/
    /*20240315 #21672 add start*/
    // let changeFlag = false;
    // const lstOption = [];
    // if(this.objCourse.ListOption && this.objCourse.ListOption.length > 0){
    //   this.objCourse.ListOption.forEach(element => {
    //     lstOption.push(element.HTSetItemCode);
    //   });
    // }
    // if(this.courseOld.ListOption && this.courseOld.ListOption.length > 0 && lstOption && lstOption.length > 0){
    //   for(let i = 0; i < lstOption.length; i++){
    //     const code = lstOption[i];
    //     20240318 #21672 modify start
    //     const check = this.courseOld.ListOption.find(x => x.HTSetItemCode !== code);
    //     if (this.util.isNullOrEmpty(check)){
    //       changeFlag = true;
    //     }
    //     for(let j = 0; j < this.courseOld.ListOption.length; j++){
    //       if(code != this.courseOld.ListOption[j].HTSetItemCode){
    //         changeFlag = true;
    //         break;
    //       }
    //     /*20240318 #21672 modify end*/
    //     }
    //   }
    // }
    // /*20240315 #21672 add end*/
    // /*20240314 #21672 add start*/
    // /*20240315 #21672 modify start*/
    // if(this.courseOld.HTCourseCode != this.objCourse.HTCourseCode)
    // /*20240318 #21672 modify start*/
    // if(this.courseOld.HTCourseCode != this.objCourse.HTCourseCode || this.courseOld.ListOption.length != this.objCourse.ListOption.length || changeFlag) {
    // if(this.courseOld.HTCourseCode != this.objCourse.HTCourseCode || 
    //   (this.courseOld.ListOption && this.objCourse.ListOption && this.courseOld.ListOption.length != this.objCourse.ListOption.length) 
    //   || changeFlag || (!this.courseOld.ListOption && this.objCourse.ListOption)) {
    // /*20240318 #21672 modify end*/  
    // /*20240315 #21672 modify end*/
    //    this.isCheckFullFrame = true;
    // }else{
    /*20240314 #21672 add end*/ 
    /*20240320 #21672 delete end*/
    const oldListHTSetItemCode = this.courseOld?.ListOption ? this.courseOld?.ListOption?.map(opt => opt.HTSetItemCode) : [];
    const oldListCommonHTSetItemCode = this.courseOld?.ListOptionCommon ? this.courseOld?.ListOptionCommon?.map(opt => opt.HTSetItemCode) : [];
    const listOldHTSetItemCode = [...oldListHTSetItemCode,...oldListCommonHTSetItemCode];
    // get old and new frame option
      /*20240329 #21672 add start*/ 
      this.oldFrameOptionBack = await this.getOldFrameOption(listOldHTSetItemCode);
      /*20240329 #21672 end start*/ 
    this.oldFrameOption = await this.getFrameOption(listOldHTSetItemCode);
    this.newFrameOption = await this.getFrameOption(this.getListHTSetItemCode());
    // get old and new ReservationStatus
    this.oldReservationStat = await this.getReservationStatus(listOldHTSetItemCode);
    this.newReservationStat = await this.getReservationStatus(this.getListHTSetItemCode());

    const oldFrame = this.oldFrameOption?.filter(res => {
      if(res.RsvYMD === this.dataReservation?.objRsvDateTime?.RsvYMD && res.RsvTime === this.dataReservation?.objRsvDateTime?.RsvTime ){
        return res;
    }})
    const newFrame = this.newFrameOption?.filter(res => {
      if(res.RsvYMD === this.dataReservation?.objRsvDateTime?.RsvYMD && res.RsvTime === this.dataReservation?.objRsvDateTime?.RsvTime ){
        return res;
    }})
    this.oldFrameOption = this.oldReservationStat?.MstExaminationFrame.length > 0 ? oldFrame : [];
    this.newFrameOption = this.newReservationStat?.MstExaminationFrame.length > 0 ? newFrame : [];
      /*20240329 #21672 delete start*/ 
      // check examination change or not
      // const getExamChange = this.newFrameOption[0]?.ListExaminationFrame.filter(res => { return !this.oldFrameOption[0]?.ListExaminationFrame.some(val => { return res.ExaminationFrameCode === val.ExaminationFrameCode})})
      // if(getExamChange!== undefined || !this.util.isNullOrEmpty(getExamChange) || getExamChange) {
      //     const isFullFrame = getExamChange.filter(ex => { 
      //       const  rsvConsumptionFrame = ex.RsvConsumptionFrame ? ex.RsvConsumptionFrame.trim() : '0';
      //       const  RsvUpperLimitFrame = ex.RsvUpperLimitFrame ? ex.RsvUpperLimitFrame.trim() : '0';
      //       return rsvConsumptionFrame >= RsvUpperLimitFrame
      //     });
      //     if(isFullFrame.length > 0 || this.util.isNullOrEmpty(isFullFrame)) {
      //       this.isCheckFullFrame = true;
      //     }
      // }
      /*20240329 #21672 delete end*/ 
      /*20240320 #21672 add start*/
      /*20240321 #21672 modify start*/
      // if(this.oldFrameOption && this.oldFrameOption.length > 0 && this.newFrameOption && this.newFrameOption.length > 0){
      //   if(this.oldFrameOption[0].ListExaminationFrame && this.oldFrameOption[0].ListExaminationFrame.length > 0 && this.newFrameOption[0].ListExaminationFrame && this.newFrameOption[0].ListExaminationFrame.length > 0){
      //     for(let i = 0; i < this.oldFrameOption[0].ListExaminationFrame.length; i++){
      //       for(let j = 0; j < this.newFrameOption[0].ListExaminationFrame.length; j++){
      //         if(this.oldFrameOption[0].ListExaminationFrame[i].ExaminationFrameCode == this.newFrameOption[0].ListExaminationFrame[j].ExaminationFrameCode){
      //           if(this.oldFrameOption[0].ListExaminationFrame[i].RsvConsumptionFrame >= this.oldFrameOption[0].ListExaminationFrame[i].RsvUpperLimitFrame){
      //             this.isCheckFullFrame = true;
      //           }
      //         }
      //       }
      //     }
      //   }
      // }
      /*���݂̑I�����ڂ����݂̓��t���ɗ\��g�𒴂��Ă��邩�ǂ����𔻒f����*/
      /*20240329 #21672 add start*/ 
      /*20240402 #21672 modify start*/ 
      let lstNameFirst: any[] = [];
      let lstName: any[] = [];
      const dataLocal = sessionStorage.getItem('ObjCourseFirstDataReservation');
      const dataLocalFirst = sessionStorage.getItem('selectedCourseFirst');
      if (!this.util.isNullOrEmpty(dataLocal)) {
        this.objCoursesession = JSON.parse(dataLocal);
      }
      if (!this.util.isNullOrEmpty(dataLocalFirst)) {
        this.selectedCourseFirst = JSON.parse(dataLocalFirst);
      }
      if(this.selectedCourseFirst.ListExamination && this.selectedCourse.ListExamination){
        for(let j = 0; j < this.selectedCourseFirst.ListExamination.length; j++){
          if(this.selectedCourseFirst.ListExamination[j].HTItemCode){
            for(let g = 0; g < this.selectedCourseFirst.ListExamination[j].HTItemCode.length; g++){
              lstNameFirst.push(this.selectedCourseFirst.ListExamination[j].HTItemCode[g])
            }
          }
        }
        if(!this.util.isNullOrBlank(this.objCoursesession.ListOption)){
          for(let j = 0; j < this.objCoursesession.ListOption.length; j++){
            lstNameFirst.push(this.objCoursesession.ListOption[j].HTItemCode)
            }
        }
        lstNameFirst = Array.from(new Set(lstNameFirst));
        for(let j = 0; j < this.selectedCourse.ListExamination.length; j++){
          if(this.selectedCourse.ListExamination[j].HTItemCode){
            for(let g = 0; g < this.selectedCourse.ListExamination[j].HTItemCode.length; g++){
              lstName.push(this.selectedCourse.ListExamination[j].HTItemCode[g])
            }
          }
        }
        if(this.objCourse.ListOption){
          for(let j = 0; j < this.objCourse.ListOption.length; j++){
          lstName.push(this.objCourse.ListOption[j].HTItemCode)
          }
        }
        lstName = Array.from(new Set(lstName));
      }
      /*20240402 #21672 modify end*/ 
      /*20240329 #21672 add end*/
      /*20240329 #21672 modify start*/
      //   if(this.oldFrameOption && this.oldFrameOption.length > 0 && this.newReservationStat.MstExaminationFrame && this.newReservationStat.MstExaminationFrame.length > 0){
      //     if(this.oldFrameOption[0].ListExaminationFrame && this.oldFrameOption[0].ListExaminationFrame.length > 0 && this.newReservationStat.MstExaminationFrame && this.newReservationStat.MstExaminationFrame.length > 0){
      //       for(let i = 0; i < this.oldFrameOption[0].ListExaminationFrame.length; i++){
      //         for(let j = 0; j < this.newReservationStat.MstExaminationFrame.length; j++){
      //           if(this.oldFrameOption[0].ListExaminationFrame[i].ExaminationFrameCode == this.newReservationStat.MstExaminationFrame[j].ExaminationFrameCode){
      //             const  rsvConsumptionFrame = this.oldFrameOption[0].ListExaminationFrame[i].RsvConsumptionFrame ? this.oldFrameOption[0].ListExaminationFrame[i].RsvConsumptionFrame.trim() : '0';
      //             const  RsvUpperLimitFrame = this.oldFrameOption[0].ListExaminationFrame[i].RsvUpperLimitFrame ? this.oldFrameOption[0].ListExaminationFrame[i].RsvUpperLimitFrame.trim() : '0';
      //             if(rsvConsumptionFrame >= RsvUpperLimitFrame){
      //               this.isCheckFullFrame = true;
      //             }
      //           }
      //         }
      //       }
      //     }
      //   }
      //   /*20240321 #21672 modify end*/
      //   /*20240320 #21672 add end*/
      // /*20240320 #21672 delete start*/
      // /*20240314 #21672 add start*/
      // // }
      // /*20240314 #21672 add end*/
      // /*20240320 #21672 delete end*/
      /*20240402 #21672 modify start*/
      let listFlag = true;
      if(this.util.isNullOrEmpty(this.objCourseOld.ListOption) && this.util.isNullOrEmpty(this.objCourse.ListOption)){
        listFlag = false;
      }
      if(this.objCourseOld && (this.objCourseOld.HTCourseCode != this.objCourse.HTCourseCode || listFlag)){
      /*20240402 #21672 modify end*/
        if(this.oldFrameOptionBack && this.oldFrameOptionBack.length > 0 && this.newReservationStat.MstExaminationFrame && this.newReservationStat.MstExaminationFrame.length > 0){
          if(this.oldFrameOptionBack[0].ListExaminationFrame && this.oldFrameOptionBack[0].ListExaminationFrame.length > 0 && this.newReservationStat.MstExaminationFrame && this.newReservationStat.MstExaminationFrame.length > 0){
            for(let i = 0; i < this.oldFrameOptionBack[0].ListExaminationFrame.length; i++){
              if(this.util.isNullOrBlank(this.oldFrameOptionBack[0].ListExaminationFrame[i].RsvUpperLimitFrame)){
                break;
              }
              /*20240402 #21672 modify start*/ 
              for(let j = 0; j < this.newReservationStat.MstExaminationFrame.length; j++){
                /*20240515 #21672 add start*/
                let ListExaminationFrame: MstExaminationFrame;
                for(let a = 0; a < this.oldFrameOptionBack.length; a++){
                  if(this.oldFrameOptionBack[a].RsvYMD == this.dataReservation?.objRsvDateTime?.RsvYMD && this.oldFrameOptionBack[a].RsvTime == this.dataReservation?.objRsvDateTime?.RsvTime){
                    ListExaminationFrame =this.oldFrameOptionBack[a];
                  }
                }
                /*20240515 #21672 add end*/
                /*20240410 #21672 modify start*/ 
                /*20240515 #21672 modify start*/ 
                // if(this.newReservationStat.MstExaminationFrame[j].ExaminationFrameCode == this.oldFrameOptionBack[0].ListExaminationFrame[i].ExaminationFrameCode){
                //   const  rsvConsumptionFrame = this.oldFrameOptionBack[0].ListExaminationFrame[i].RsvConsumptionFrame ? this.oldFrameOptionBack[0].ListExaminationFrame[i].RsvConsumptionFrame.trim() : '0';
                //   const  RsvUpperLimitFrame = this.oldFrameOptionBack[0].ListExaminationFrame[i].RsvUpperLimitFrame ? this.oldFrameOptionBack[0].ListExaminationFrame[i].RsvUpperLimitFrame.trim() : '0';
                if(this.newReservationStat.MstExaminationFrame[j].ExaminationFrameCode == ListExaminationFrame.ListExaminationFrame[i].ExaminationFrameCode){
                  const  rsvConsumptionFrame = ListExaminationFrame.ListExaminationFrame[i].RsvConsumptionFrame ? ListExaminationFrame.ListExaminationFrame[i].RsvConsumptionFrame.trim() : '0';
                  const  RsvUpperLimitFrame = ListExaminationFrame.ListExaminationFrame[i].RsvUpperLimitFrame ? ListExaminationFrame.ListExaminationFrame[i].RsvUpperLimitFrame.trim() : '0';
                /*20240515 #21672 modify end*/ 
                  let lock = lstNameFirst.includes(this.newReservationStat.MstExaminationFrame[j].HTItemCode);
                  let lock1 = lstName.includes(this.newReservationStat.MstExaminationFrame[j].HTItemCode);
                  if(rsvConsumptionFrame >= RsvUpperLimitFrame && lock == false && lock1){
          this.isCheckFullFrame = true;
                  }
                }
              }
              /*20240410 #21672 modify end*/ 
            }
            /*20240329 #21672 add start*/ 
            for(let i = 0; i < this.newFrameOption[0].ListExaminationFrame.length; i++){
              if(this.util.isNullOrBlank(this.newFrameOption[0].ListExaminationFrame[i].RsvUpperLimitFrame)){
                break;
              }
              for(let j = 0; j < this.newReservationStat.MstExaminationFrame.length; j++){
                /*20240515 #21672 add start*/
                let ListExaminationFrame: MstExaminationFrame;
                for(let a = 0; a < this.newFrameOption.length; a++){
                  if(this.newFrameOption[a].RsvYMD == this.dataReservation?.objRsvDateTime?.RsvYMD && this.newFrameOption[a].RsvTime == this.dataReservation?.objRsvDateTime?.RsvTime){
                    ListExaminationFrame =this.newFrameOption[a];
                  }
                }
                /*20240515 #21672 add end*/
                /*20240410 #21672 modify start*/ 
                /*20240515 #21672 modify start*/ 
                // if(this.newReservationStat.MstExaminationFrame[j].ExaminationFrameCode == this.newFrameOption[0].ListExaminationFrame[i].ExaminationFrameCode){
                //   const  rsvConsumptionFrame = this.newFrameOption[0].ListExaminationFrame[i].RsvConsumptionFrame ? this.newFrameOption[0].ListExaminationFrame[i].RsvConsumptionFrame.trim() : '0';
                //   const  RsvUpperLimitFrame = this.newFrameOption[0].ListExaminationFrame[i].RsvUpperLimitFrame ? this.newFrameOption[0].ListExaminationFrame[i].RsvUpperLimitFrame.trim() : '0';
                if(this.newReservationStat.MstExaminationFrame[j].ExaminationFrameCode == ListExaminationFrame.ListExaminationFrame[i].ExaminationFrameCode){
                  const  rsvConsumptionFrame = ListExaminationFrame.ListExaminationFrame[i].RsvConsumptionFrame ? ListExaminationFrame.ListExaminationFrame[i].RsvConsumptionFrame.trim() : '0';
                  const  RsvUpperLimitFrame = ListExaminationFrame.ListExaminationFrame[i].RsvUpperLimitFrame ? ListExaminationFrame.ListExaminationFrame[i].RsvUpperLimitFrame.trim() : '0';
                /*20240515 #21672 modify start*/ 
                  let lock = lstNameFirst.includes(this.newReservationStat.MstExaminationFrame[j].HTItemCode);
                  let lock1 = lstName.includes(this.newReservationStat.MstExaminationFrame[j].HTItemCode);
                  if(rsvConsumptionFrame >= RsvUpperLimitFrame && lock == false && lock1){
                    this.isCheckFullFrame = true;
                  }
                }
                /*20240410 #21672 modify end*/ 
              }
            }
            /*20240402 #21672 modify end*/ 
            /*20240329 #21672 add end*/ 
          }
        }
    }
      /*20240321 #21672 modify end*/
      /*20240320 #21672 add end*/
    /*20240320 #21672 delete start*/
    /*20240314 #21672 add start*/
    // }
    /*20240314 #21672 add end*/
    /*20240320 #21672 delete end*/
    /*20240329 #21672 modify end*/
  }
  private async getReservationStatus(setItemCode:any) {
    this.loadingSrv.setDisplay(true);
    const objSearch = {
      StartDate: moment(this.startDate).format('YYYYMMDD'),
      EndDate: moment(this.endDate).format('YYYYMMDD'),
      HTOrgCode: this.HTOrgCode,
      RsvGender: this.objUser.Gender,
      HTCourseCode: this.dataReservation.objCourse?.HTCourseCode,
      CoCode: this.dataReservation.objCourse?.CoCode,
      HTSetItemCode: setItemCode,
      DateOfBirth: this.objUser.DateOfBirth
    };
    return new Promise<any>((resolve) => {
      this.reservationDateSelService.searchReservationStatus(objSearch).subscribe(data => {
        return resolve(data)
      })})

  }
  /* 20231006 add #19525 start */ 
  async deleteConcurrent() {
    const pConcurrent = {
      KeyDate: this.RsvDateParam,
      KeyNum: this.RsvNumParam,
      HtOrgCode: this.HTOrgCode,
      ScreenDiv: '0'
    };
    await this.common.DeleteConcurent(pConcurrent).toPromise();
  }

  @HostListener('window:unload', ['$event'])
  unload(event: Event) {
    this.deleteConcurrent();
  }

  ngOnDestroy(): void {
    this.deleteConcurrent();
  }
  /* 20231006 add #19525 end */  
}

export class ReservationStatus {
  MstExaminationFrame: MstExaminationFrame[] = [];
  RsvTime: string;
  RsvYMD: string;
}

export class MstExaminationFrame {
  ListExaminationFrame: ListExaminationFrame [] = [];
  RsvTime: string;
  RsvYMD: string;
  /* 20241108 #20724 add start */
  Gender: string;
  /* 20241108 #20724 add end */
  RsvGender: string;
}
export class ListExaminationFrame {
  ExaminationFrameCode: string;
  ExaminationFrameName: string;
  RsvConsumptionFrame: string;
  RsvUpperLimitFrame: string;
}
